import { SNIPE_LIFETIME_MS } from '../constants/feel';

export const LASER_STYLE = { color: '#EFE4B0', lineWidth: 2 } as const;

const LASER_ALPHA_BASE = 0.4;
const LASER_ALPHA_FADE = 0.4;

export const MISS_BEAM_LENGTH = 600;

export const DEFAULT_IMPACT_SCATTER = 20;

export interface Laser {
  readonly x1: number;
  readonly y1: number;
  readonly x2: number;
  readonly y2: number;
  readonly at: number;
}

export function laserAlpha(laser: Laser, now: number): number {
  const age = now - laser.at;
  if (age < 0 || age > SNIPE_LIFETIME_MS) return 0;
  return LASER_ALPHA_BASE - (age / SNIPE_LIFETIME_MS) * LASER_ALPHA_FADE;
}

export class LaserField {
  private readonly live: Laser[] = [];

  get all(): readonly Laser[] {
    return this.live;
  }

  get count(): number {
    return this.live.length;
  }

  add(x1: number, y1: number, x2: number, y2: number, now: number): void {
    this.live.push({ x1, y1, x2, y2, at: now });
  }

  advance(now: number): void {
    let write = 0;
    for (const laser of this.live) {
      if (now > laser.at + SNIPE_LIFETIME_MS) continue;
      this.live[write++] = laser;
    }
    this.live.length = write;
  }

  clear(): void {
    this.live.length = 0;
  }
}
